/**
 * React Node Renderer (Web)
 * Renders a provided React node without validation or extra UI.
 * Accepts either `field.node` or `field.reactNode`.
 */

import React from 'react';
import type { FieldRenderer } from '@/MyCode/core';

export const renderReactNode: FieldRenderer<React.ReactNode> = ({ field }) => {
  const node = (field as any).node ?? (field as any).reactNode;
  if (!node) return null;
  return <>{node}</>;
};

export default renderReactNode;

